import { ACCEPTED_FILE_FORMATS, MAX_FILE_SIZE_BYTES } from '../constants';

const validateFileSize = (file: File | null | undefined) => (!file ? true : file.size <= MAX_FILE_SIZE_BYTES);

const validateFileFormat = (file: File | null | undefined) =>
  !file ? true : ACCEPTED_FILE_FORMATS.some((format) => file.name.endsWith(format));

export { validateFileFormat, validateFileSize };
